import App from 'app/app.js';

function CachedArrayDataFactory() {
  var factory = {
    // This function is a wrapper to handle setting data within an array of cached items.
    // The 'opts' parameter must specify if the 'data' parameter is an array, this is done by setting
    // opts.cachedItemIsArray = true. 'opts' must also contain a property for the unique id property of the
    // individual objects held in the cached array.
    handleDataArrayToCache: function (data, opts, cachedObj, appendableData) {
      if (opts.isArray) {
        if (cachedObj === null || cachedObj.constructor !== Array) {
          cachedObj = [];
        }
      }

      if (data === null) {
        data = {};
      }

      var id = R.path(opts.propertyMap, data),
        isEqual = R.pathEq(opts.propertyMap, id),
        index = R.findIndex(isEqual, cachedObj);

      if (index < 0) {
        cachedObj.push(data);
      } else {
        cachedObj[index] = data;
      }

      return cachedObj;
    },

    setDictionaryData: function (key, data, cachedObj) {
      if (!cachedObj || cachedObj.constructor !== Array) {
        cachedObj = [];
      }

      var isEqual = function (item) {
          return item.key === key;
        },
        index = R.findIndex(isEqual, cachedObj),
        val = { key: key, value: data };

      if (index === -1) {
        cachedObj.push(val);
        return cachedObj;
      }

      cachedObj[index] = val;
      return cachedObj;
    },

    getDictionaryData: function (key, cachedObj) {
      if (!cachedObj) {
        return {};
      }

      var isEqual = function (item) {
          return item.key === key;
        },
        index = R.findIndex(isEqual, cachedObj);

      if (index > -1) {
        return cachedObj[index];
      }

      return {};
    },

    getArrayObjectById: function (id, opts, cachedObj) {
      if (!cachedObj) {
        return {};
      }

      var isEqual = R.pathEq(opts.propertyMap, id),
        index = R.findIndex(isEqual, cachedObj);

      if (index > -1) {
        return cachedObj[index];
      }

      return {};
    }
  };

  return factory;
}

App.factory('CachedArrayDataFactory', [CachedArrayDataFactory]);
